/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { protectedSymmetricKeySchema } from "./protectedSymmetricKeySchema.ts"
import { tokenTypeSchema } from "./tokenTypeSchema.ts"
import { z } from "zod/v4"

/**
 * @description Successfully signed up for an account
 */
export const signup200Schema = z.object({
  id: z.string(),
  accessToken: z.string().min(1).describe("Access token for authentication"),
  refreshToken: z
    .string()
    .min(1)
    .describe("Refresh token for obtaining new access tokens"),
  scope: z.string().min(1).describe("Scopes granted to the access token"),
  get tokenType() {
    return tokenTypeSchema.describe('Type of the token, typically "Bearer"')
  },
  expiresAt: z.string().datetime().describe("When the session expires"),
})

/**
 * @description Invalid request to signup
 */
export const signup400Schema = APIErrorSchema

export const signupMutationRequestSchema = z.object({
  id: z.string().min(1),
  username: z.string().min(1),
  masterPasswordHash: z.string().min(32),
  get protectedUserSymmetricKey() {
    return protectedSymmetricKeySchema.describe(
      "A protected symmetric key is one that is base64 encoded and contains the initialization vector and the ciphertext",
    )
  },
  protectedProfileSymmetricKey: z.string().min(1),
  protectedRsaPrivateKey: z.string().min(1),
  rsaPublicKey: z.string().min(1),
  email: z.email().optional(),
  phoneNumber: z.string().optional(),
  discoverabilitySettings: z
    .object({
      discoverableByUsername: z.boolean().default(true),
      discoverableByEmail: z.boolean().default(false),
      discoverableByPhone: z.boolean().default(false),
    })
    .describe("Settings for profile discoverability"),
  clientID: z.string().min(1).describe("Used for analytics").optional(),
})

export const signupMutationResponseSchema = signup200Schema
